<template>
  <div v-if="talkShow" class="ai_talkbox_wrapper font-color-primary">
    <div class="ai_talkbox_header">
      <span class="ai_img"><img :src="`${syImgUrl}/16214793829079456.svg`" alt=""></span>
      <span class="ai_name">{{pageText.myCustomerService}}</span>
      <span class="ai_close" @click="minus" :data-spm-d="ChatWindowBuriedPoint.toMinus"><i class="el-icon-minus"></i></span>
      <span class="ai_close" @click="hide" :data-spm-d="ChatWindowBuriedPoint.toClose"><i class="el-icon-close"></i></span>
    </div>
    <div class="ai_talkbox_content">
      <div class="ai_talkbox_content_box" ref="talkboxCon">
        <div v-for="(item, index) in talkList" :key="index" class="talkbox-item">
          <div v-if="item.isAI" class="ai-box">
            <p class="time">{{item.time}}</p>
            <div v-if="item.type === 'selectSend' && item.content.fastReply">
              <div class="talk-con">
                {{item.content.fastReply}}
                <p v-if="item.content.replyContentUrl">
                  <SyLink class="font-color-link" :to="{path: '/help/detail', query: {sysCode: item.content.sysCode}}" target="_blank" :data-spm-d="ChatWindowBuriedPoint.toViewDetails">{{pageText.viewDetails}}</SyLink>
                </p>
              </div>
            </div>
            <div v-else-if="item.type === 'oneSearchResult'">
              <div class="talk-con">
                {{item.content.fastReply}}
                 <p v-if="item.content.replyContentUrl">
                  <SyLink class="font-color-link" :to="{path: '/help/detail', query: {sysCode: item.content.sysCode}}" target="_blank" :data-spm-d="ChatWindowBuriedPoint.toViewDetails">{{pageText.viewDetails}}</SyLink>
                </p>
              </div>
              <div class="help-link">
                {{pageText.CanFindTheAnswerGoToThe}}
                <SyLink class="font-color-link" :to="{path: '/help/list', query: {title: item.words}}" target="_blank" :data-spm-d="ChatWindowBuriedPoint.toHelpCenter">{{pageText.helpCenter}}</SyLink>
                {{pageText.seeMoreAnswers}}
              </div>
            </div>
            <div v-else-if="item.type === 'noOneSearchResult'">
              <div class="talk-con talk-con-list">
                <p class="title">{{pageText.supposeYouWantToAsk}}</p>
                <ul class="font-color-primary">
                  <li v-for="(itemCon, i) in item.content" :key="i" @click="selectReply(itemCon)">
                    <p v-if="itemCon.highlightedTitleList.length" v-html="itemCon.highlightedTitleList[0]"></p>
                    <p v-else>{{itemCon.title}}</p>
                  </li>
                </ul>
              </div>
              <div class="help-link">
                {{pageText.CanFindTheAnswerGoToThe}}
                <SyLink class="font-color-link" :to="{path: '/help/list', query: {title: item.words}}" target="_blank" :data-spm-d="ChatWindowBuriedPoint.toHelpCenter">{{pageText.helpCenter}}</SyLink>
                {{pageText.seeMoreAnswers}}
              </div>
            </div>
            <div v-else-if="item.type === 'noSearchResult'">
              <div class="talk-con">{{item.content.fastReply}}</div>
              <div class="help-link">
                {{pageText.youCanAlsoAskAnotherQuestionToTryOrTo}}
                <SyLink class="font-color-link" :to="{path: '/help/list'}" target="_blank" :data-spm-d="ChatWindowBuriedPoint.toHelpCenter">{{pageText.helpCenter}}</SyLink>
                {{pageText.queryMore}}
              </div>
            </div>
            <div v-else>
              <div class="talk-con">{{item.content}}</div>
            </div>
          </div>
          <div v-else class="user-box">
            <p class="time">{{item.time}}</p>
            <div class="talk-con">{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ai_talkbox_bottom">
      <div>
        <el-autocomplete
          ref="autocomplete"
          popper-class="query-search-question-popper"
          v-model="words"
          :fetch-suggestions="querySearchQuestion"
          :placeholder="pageText.pleaseDescribeTheProblemYouEncountered"
          @select="handleSelect"
          @input="input"
          @focus="focus"
          class="ai_send_text"
          type="textarea"
          hide-loading
          :trigger-on-focus="false"
          debounce="0"
          @keydown.native="keyDown"
        >
          <!-- <template slot-scope="{ item }">
            <template v-if="item.highlightedTitleList">
              <div class="name" v-html="item.highlightedTitleList[0]"></div>
            </template>
          </template> -->
        </el-autocomplete>
        <ul v-if="replyListShow" class="reply-list">
          <p class="title">{{pageText.supposeYouWantToAsk}}</p>
          <li v-for="(item, index) in replyList" :key="index" @click="handleSelect(item)" :data-spm-d="ChatWindowBuriedPoint.sendBuriedPoint">
            <template v-if="item.highlightedTitleList.length">
              <div class="name" v-html="item.highlightedTitleList[0]"></div>
            </template>
            <div v-else class="name">{{item.title}}</div>
          </li>
        </ul>
      </div>
      <div class="ai_send_button">
        <el-button size="medium" @click="send" :data-spm-d="ChatWindowBuriedPoint.sendBuriedPoint">{{pageText.send}}<i class="line"></i></el-button>
        <el-dropdown class="dropdown-icon font-color-primary" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu class="font-color-primary" slot="dropdown">
            <el-dropdown-item
              class="font-color-primary"
              v-for="(item, index) in sendBtnType"
              :key="index"
              :style="{'background': keyWay === item.value ? 'currentColor': ''}"
              :command="item.value"
            >
              <span :class="[keyWay === item.value ? 'select' : '' ]">{{item.text}}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import aiApi from './api.js'
import getData from '../../../../utils/response'
import { componentMessage } from '../../utils'
import moment from 'moment'
import i18n from './i18n.js'
import { SyLink } from './../../../../index.js'
const pageText = window.fe.getPageText(i18n)
export default {
  components: {
    SyLink
  },
  props: {
    talkShow: {
      type: Boolean,
      default: false
    },
    ChatWindowBuriedPoint: {
      type: Object,
      default: {
        sendBuriedPoint: null,
        openBuriedPoint: null,
        toHelpCenter: null,
        toViewDetails: null,
        toMinus: null,
        toClose: null
      }
    }
  },
  watch: {
    talkShow (val) {
      // 当打开的时候进行打开的埋点
      if (val && this.ChatWindowBuriedPoint.openBuriedPoint) {
        window.fe.spmD(this.ChatWindowBuriedPoint.openBuriedPoint)
      }
      if (val && !this.talkList.length) {
        this.getOpenConnected()
      }
      console.log(val)
    }
  },
  data () {
    return {
      pageText,
      moment,
      sendBtnType: [
        {
          value: '0',
          text: pageText.pressEnterToSend
        },
        {
          value: '1',
          text: pageText.pressCtrlEnterToSend
        }
      ],
      keyWay: '0', // 0: 按enter, 1:按ctrl+enter
      isSelectSend: false, // 是否选择发送
      isSearchResult: true, //有无搜索结果
      isOneSearchResult: false, //是否只有一条搜索结果
      talkList: [], // 聊天记录
      words: '', // 输入内容
      replyList: [], // 输入搜索结果list
      replyListShow: false, // 搜索结果是否展示
      replyCon: null, // 回复内容
      project: window.fe.project
    }
  },
  created () {
    // 适用于供应商端 采购商端 商城端
    let flag = componentMessage(['supplier', 'purchaser', 'mall'], 'chat-window智能客服')
    if (flag) return
  },
  methods: {
    hide () {
      this.talkShow = false
      this.talkList = []
      this.$emit('update:talkShow', this.talkShow)
    },
    minus () {
      this.talkShow = false
      this.$emit('update:talkShow', this.talkShow)
    },
    // 获取问候语
    async getOpenConnected () {
      const api = aiApi.openConnected
      let result = await getData(this.$http(api.type, api.url))
      if (result.code === 'success' && result.content) {
        this.talkList.push({
          isAI: true,
          type: 'greetings',
          content: result.content.content || '',
          time: this.moment().format('YYYY-MM-DD HH:mm:ss')
        })
      }
    },
    // 输入内容请求数据
    async querySearchQuestion (query, cb) {
      const api = aiApi.searchQuestion
      let params = {
        title: query,
        page: 1,
        pageSize: 5
      }
      let result = await getData(this.$http(api.type, api.url, params))
      if (result.code === 'success' && result.content.length) {
        this.isOneSearchResult = result.content[0].sysCode && result.content.length === 1
        this.isSearchResult = !!result.content[0].sysCode
        if (!this.isSelectSend) {
          this.replyCon = result.content
        }
        if (cb) {
          let newResult = []
          if (result.content.length && this.isSearchResult) {
            // newResult.push({highlightedTitleList: ['猜你想问']})
            newResult.push(...result.content)
          }
          cb(newResult)
          this.replyList = newResult
          this.replyListShow = !!this.replyList.length
        }
      }
    },
    input () {
      this.replyCon = null
      this.isSelectSend = false
      // 删除输入为空清空list
      if (!this.words) {
        this.replyList = []
        this.replyListShow = false
      }
    },
    focus () {
      this.$refs.autocomplete.close()
    },
    handleSelect (val) {
      this.selectReply(val)
      this.words = ''
      this.replyListShow = false
    },
    keyDown (event) {
      let keyCode = event.keyCode || event.which || event.charCode
      let ctrlKey = event.ctrlKey || event.metaKey
      if (this.keyWay === '0' && keyCode === 13 && !ctrlKey) {
        event.preventDefault()
        this.send()
        window.fe.spmD(this.ChatWindowBuriedPoint.sendBuriedPoint)
      }
      if (this.keyWay === '1' && keyCode === 13 && ctrlKey) {
        this.send()
        window.fe.spmD(this.ChatWindowBuriedPoint.sendBuriedPoint)
      }
    },
    handleCommand (command) {
      this.keyWay = command
    },
    // 发送
    async send () {
      if (!this.words) {
        return false
      }
      this.replyListShow = false
      this.replyList = []
      this.talkList.push({
        isAI: false,
        content: this.words,
        time: this.moment().format('YYYY-MM-DD HH:mm:ss')
      })
      if (this.isSelectSend) {
        console.log(this.replyCon, 8)
        this.talkList.push({
          isAI: true,
          type: 'selectSend',
          words: this.words,
          content: this.replyCon.fastReply,
          sysCode: this.replyCon.sysCode || '',
          replyContentUrl: this.replyCon.replyContentUrl || '',
          time: this.moment().format('YYYY-MM-DD HH:mm:ss')
        })
      } else {
        await this.querySearchQuestion(this.words)
        let obj = {
          isAI: true,
          words: this.words,
          content: this.replyCon,
          time: this.moment().format('YYYY-MM-DD HH:mm:ss')
        }
        if (!this.isSearchResult) {
          obj.type = 'noSearchResult'
          obj.content = this.replyCon[0]
        } else {
          if (this.isOneSearchResult) {
            obj.type = 'oneSearchResult'
            obj.content = this.replyCon[0]
          } else {
            obj.type = 'noOneSearchResult'
          }
        }
        this.talkList.push(obj)
      }
      this.words = ''
      this.$nextTick(() => {
        this.$refs.talkboxCon.scrollTop = this.$refs.talkboxCon.scrollHeight // 滚动高度
      })
    },
    // 选择多条记录的一条
    selectReply (item) {
      console.log(item, 81)
      let isNoAiObj = {
        isAI: false,
        content: item.title,
        time: this.moment().format('YYYY-MM-DD HH:mm:ss')
      }
      let isAiObj = {
        isAI: true,
        type: 'selectSend',
        content: item,
        time: this.moment().format('YYYY-MM-DD HH:mm:ss')
      }
      this.talkList.push(isNoAiObj, isAiObj)
      this.$nextTick(() => {
        this.$refs.talkboxCon.scrollTop = this.$refs.talkboxCon.scrollHeight // 滚动高度
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .ai_talkbox_wrapper {
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 2000;
    background-color: currentColor;
    width: 360px;
    height: 540px;
    border-radius: 6px 6px 0 0;
    .ai_talkbox_header {
      height: 48px;
      line-height: 48px;
      display: flex;
      color: #fff;
      .ai_img {
        display: inline-block;
        width: 56px;
        height: 56px;
        margin-top: 20px;
        margin-left: 15px;
        margin-right: 8px;
        z-index: 1;
        // background-image: radial-gradient(50% 137%, #FFFFFF 0%, #DFE9FF 100%);
        text-align: center;
        border-radius: 50%;
        img {
          margin-top: 10px;
        }
      }
      .ai_name{
        flex: 1;
        font-size: 16px;
        font-weight: 500;
      }
      .ai_close {
        width: 34px;
      }
    }
    .ai_talkbox_content {
      color: #243445;
      width: 354px;
      height: 350px !important;
      padding-top: 38px;
      margin-left: 3px;
      display: block;
      max-height: 488px;
      background: #F5F8FA;
      border-radius: 4px 4px 0 0;
      .ai_talkbox_content_box {
        overflow-x: hidden;
        overflow-y: auto;
        height: inherit;
      }
      .talkbox-item {
        margin: 0 16px 16px;
        overflow: hidden;
      }
      .time {
        font-size: 12px;
        color: #BCC2CA;
        height: 17px;
        margin-top: 10px;
      }
      .help-link {
        font-size: 12px;
        color: #90969D;
        letter-spacing: 0;
        height: 17px;
        margin-top: 4px;
      }
      .talk-con-list {
        max-width: 286px !important;
        padding: 10px 0 !important;
        .title {
          height: 40px;
          line-height: 40px;
          border-bottom: #F3F5F8 solid 1px;
          color: #243445;
          font-weight: 600;
          margin-bottom: 6px;
          pointer-events: none;
          padding: 0 10px;
          margin-top: -10px;
        }
        ul li::before {
          content: '';
          float: left;
          display: inline-block;
          width: 4px;
          height: 4px;
          background-color: currentColor;
          margin-top: 12px;
          margin-right: 6px;
        }
        li {
          padding: 0px 10px;
          cursor: pointer;
        }
        li p:hover {
          background-color: #fff;
          color: #3072F3;;
        }
        p {
          line-height: 18px;
          // border-bottom: #F3F5F8 solid 1px;
          color: #666;
          font-weight:400;
          padding: 5px 0 5px 10px;
          cursor: pointer;
        }
      }
      .ai-box {
        .talk-con {
          max-width: 260px;
          line-height: 18px;
          padding: 8px 10px;
          background: #FFFFFF;
          border: 1px solid #F5F8F9;
          border-radius: 0 20px 20px 20px;
          word-break: break-all;
        }
      }
      .user-box {
        float: right;
        overflow: hidden;
        .talk-con {
          float: right;
          max-width: 216px;
          line-height: 18px;
          padding: 8px 10px;
          background: #5D9EF6;
          color: #fff;
          border-radius: 20px 0px 20px 20px;
          word-break: break-all;
        }
      }
    }
    .ai_talkbox_bottom {
      width: 354px;
      color: #243445;
      background-color: #fff;
      color: #243445;
      margin-left: 3px;
      .ai_send_text {
        width: 248px !important;
        border: 0 solid #fff;
        border-radius: 4px;
        font-size: 14px;
        height: 70px;
        line-height: 22px;
        overflow: hidden;
        resize: none;
        // vertical-align: top;
        padding: 18px 11px 16px 11px;
        outline: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        ::v-deep .el-textarea__inner {
          height: 70px;
          border: none;
          resize: none;
          font-size: 14px;
          padding: 0;
        }
      }
      .ai_send_button {
        position: absolute;
        bottom: 17px;
        right: 14px;
        display: inline-flex;
        cursor: pointer;
        background-color: transparent;
        padding: 0;
        ::v-deep .el-button {
          width: 73px;
          height: 28px;
          line-height: 28px;
          padding: 0 0 0 8px;
          background: #5D9EF6;
          color: #fff;
          font-weight: 400;
          span {
            margin-right: 20px;
          }
          .line {
            display: inline-block;
            width: 1px;
            height: 12px;
            background-color: #fff;
            margin-left: 6px;
            opacity: 0.5;
          }
        }
        .dropdown-icon {
          color: #fff;
          position: absolute;
          right: 0;
          top: 5px;
          width: 27px;
          cursor: pointer;
          .el-dropdown-link {
            padding: 10px 0;
          }
          .el-icon-caret-bottom {
            color: #fff;
          }
        }
      }

      .reply-list {
        position: absolute;
        bottom: 105px;
        background: #fff;
        width: 354px;
        box-shadow: 0 -8px 12px 0 rgba(0,0,0,0.04);
        border-radius: 8px 8px 0 0;
        .title {
          height: 40px;
          line-height: 40px;
          border-bottom: #F3F5F8 solid 1px;
          color: #243445;
          font-weight: 600;
          margin-bottom: 6px;
          pointer-events: none;
          padding: 0 10px;
        }
        li {
          cursor: pointer;
          color: #666;
          padding: 4px 10px;
          margin-bottom: 6px;
          white-space: normal;
          .name {
            line-height: 26px;
          }
        }
        li:hover {
          background-color: #fff;
          color: #3072F3;
        }
        // li:first-child{
        //   height: 40px;
        //   line-height: 40px;
        //   border-bottom: #F3F5F8 solid 1px;
        //   color: #243445;
        //   font-weight: 500;
        //   margin-bottom: 6px;
        //   pointer-events: none;
        // }
      }
    }
  }
</style>
<style lang="scss">
.el-popper.query-search-question-popper {
  width: 352px !important;
  border: none;
  // margin-left: 4px !important;
  // margin-top: -22px !important;
  .popper__arrow {
    display: none;
  }
  .popper__arrow::after{
    display: none;
  }
  .el-autocomplete-suggestion__wrap {
    padding: 0 0 27px 0;
    li {
      color: #243445;
      padding: 6px 11px;
      white-space: normal;
      .name {
        line-height: 26px;
      }
    }
    li:hover {
      background-color: #fff;
      color: #3072F3;
    }
    li:first-child{
      height: 40px;
      line-height: 40px;
      border-bottom: #F3F5F8 solid 1px;
      color: #243445;
      font-weight: 500;
      margin-bottom: 6px;
      pointer-events: none;
    }
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    color: currentColor;
  }
  .el-dropdown-menu__item span {
    color: #333;
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    color: currentColor;
  }
  .select {
    color: #fff !important;
  }
}
.query-search-question-popper {
  .name em {
    color: red;
  }
}
.talk-con-list,.reply-list {
  em {
    color: red;
  }
}
</style>
